module.exports = __webpack_public_path__ + "img/follow_img2.f26f575c.png";